@if (showError) {
  <div class="error">
    Er is iets mis gegaan met het ophalen van de voorstellingen. Mogelijk een probleem tijdens het verbinden met de server.
    Probeer het later nog eens.
    Als dit probleem zich blijft voordoen, neem dan aub contact op met Roy.
  </div>
}

<!--<ion-label *ngIf="performances.length === 0 && !showError && !isLoadPerformancesLoading">-->
<!--  <p style="margin-top: 2rem; text-align: center; color:black;">Er zijn geen speeldata gevonden...<br><br>Vraag aan de beheerder om speeldata toe te voegen.</p>-->
<!--</ion-label>-->

<!--<div *ngIf="performances.length !== 0" class="card-container">-->

<!--  <app-next-performance-card *ngIf="showNextPerformanceCard()" [shouldRefresh]="shouldRefresh"/>-->

<!--  <app-performance-card *ngFor="let performance of performances; trackBy: trackByFunction" [performance]="performance" [isDesktop]="isDesktop" data-cy="dashboard-performance-card-list"/>-->

<!--  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)" *ngIf="isInfiniteScrollEnabled" threshold="20%">-->
<!--    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Meer voorstellingen ophalen..."></ion-infinite-scroll-content>-->
<!--  </ion-infinite-scroll>-->

<!--</div>-->
